// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popup-menu-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
  opacity: 0;
  visibility: hidden;
  transition: all 0.15s ease-in-out;
  background-image: linear-gradient(rgba(79, 36, 172, 0.85) 0%, rgba(79, 36, 172, 0.65) 100%);
}
.popup-menu-overlay.in {
  opacity: 1;
  visibility: visible;
}

.popup-menu-toggle {
  position: fixed;
  width: 40px;
  height: 40px;
  bottom: 10px;
  left: 50%;
  margin-left: -20px;
  background-color: var(--ion-color-primary);
  border-radius: 50%;
  z-index: 101;
  transition: all 0.25s ease-in-out;
}
.popup-menu-toggle.out {
  opacity: 0;
  visibility: hidden;
  transform: scale(0);
  transition: all 0.15s ease-in-out;
}
.popup-menu-toggle.out:before {
  transition: all 0.15s ease-in-out;
  transform: scale(0);
}

.popup-menu-panel {
  position: fixed;
  width: 300px;
  border-radius: 5%;
  bottom: 80px;
  left: 50%;
  margin-left: -150px;
  padding: 20px;
  background-color: var(--ion-color-primary);
  z-index: 102;
  transition: all 0.25s ease-in-out;
  transition-delay: 0.15s;
  transform-origin: 50% 100%;
  transform: scale(0);
  display: -moz-flex;
  display: flex;
  flex-wrap: wrap;
}
.popup-menu-panel .popup-menu-item {
  margin: auto;
  -moz-flex: 1 0 30%;
  flex: 1 0 30%;
  display: -moz-flex;
  display: flex;
  -moz-flex-direction: column;
  flex-direction: column;
  transform: scale(0);
  opacity: 0;
  transition: all 0.25s ease-in-out;
}
.popup-menu-panel .popup-menu-item ion-icon {
  margin: 0 auto;
  text-align: center;
  color: #fff;
}
.popup-menu-panel .popup-menu-item span {
  padding: 0;
  margin: 0 0 auto 0;
  color: #fff;
  text-align: center;
  font-size: 12px;
  text-transform: uppercase;
  font-weight: 500;
  line-height: 18px;
}
.popup-menu-panel .popup-menu-item:active i {
  color: rgb(221, 65, 53);
  transition: all 0.15s;
}
.popup-menu-panel .popup-menu-item:active span {
  color: rgb(221, 65, 53);
  transition: all 0.15s;
}
.popup-menu-panel.in {
  transform: scale(1);
  transition-delay: 0s;
}
.popup-menu-panel.in .popup-menu-item {
  transform: scale(1);
  opacity: 1;
  transition-delay: 0.15s;
}`, "",{"version":3,"sources":["webpack://./src/app/components/popmenu/popmenu.component.scss"],"names":[],"mappings":"AACA;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EAEA,iCAAA;EAEA,2FAAA;AAAJ;AACI;EACI,UAAA;EACA,mBAAA;AACR;;AAGA;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;EACA,0CAAA;EACA,kBAAA;EACA,YAAA;EAEA,iCAAA;AAAJ;AACI;EACI,UAAA;EACA,kBAAA;EAEA,mBAAA;EAEA,iCAAA;AACR;AAAQ;EAEI,iCAAA;EAEA,mBAAA;AAEZ;;AAGA;EACI,eAAA;EACA,YAAA;EAEA,iBAAA;EACA,YAAA;EACA,SAAA;EACA,mBAAA;EACA,aAAA;EACA,0CAAA;EACA,YAAA;EAEA,iCAAA;EAEA,uBAAA;EAEA,0BAAA;EAEA,mBAAA;EAIA,kBAAA;EAEA,aAAA;EAIA,eAAA;AADJ;AAEI;EACI,YAAA;EAIA,kBAAA;EAEA,aAAA;EAIA,kBAAA;EAEA,aAAA;EAIA,2BAAA;EAEA,sBAAA;EAEA,mBAAA;EACA,UAAA;EAEA,iCAAA;AAAR;AACQ;EACI,cAAA;EACA,kBAAA;EACA,WAAA;AACZ;AACQ;EACI,UAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,iBAAA;AACZ;AAEY;EACI,uBAAA;EAEA,qBAAA;AAAhB;AAEY;EACI,uBAAA;EAEA,qBAAA;AAAhB;AAII;EAEI,mBAAA;EAEA,oBAAA;AAFR;AAGQ;EAEI,mBAAA;EACA,UAAA;EAEA,uBAAA;AADZ","sourcesContent":["// Popup Menu //\r\n.popup-menu-overlay {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    z-index: 100;\r\n    opacity: 0;\r\n    visibility: hidden;\r\n    -webkit-transition: all 0.15s ease-in-out;\r\n    transition: all 0.15s ease-in-out;\r\n    background-image: -webkit-linear-gradient(rgba(79,36,172, .85) 0%, rgba(79,36,172, .65) 100%);\r\n    background-image: linear-gradient(rgba(79,36,172, .85) 0%, rgba(79,36,172, .65) 100%);\r\n    &.in {\r\n        opacity: 1;\r\n        visibility: visible;\r\n    }\r\n}\r\n\r\n.popup-menu-toggle {\r\n    position: fixed;\r\n    width: 40px;\r\n    height: 40px;\r\n    bottom: 10px;\r\n    left: 50%;\r\n    margin-left: -20px;\r\n    background-color: var(--ion-color-primary);\r\n    border-radius: 50%;\r\n    z-index: 101;\r\n    -webkit-transition: all .25s ease-in-out;\r\n    transition: all .25s ease-in-out;\r\n    &.out {\r\n        opacity: 0;\r\n        visibility: hidden;\r\n        -webkit-transform: scale(0);\r\n        transform: scale(0);\r\n        -webkit-transition: all .15s ease-in-out;\r\n        transition: all .15s ease-in-out;\r\n        &:before {\r\n            -webkit-transition: all .15s ease-in-out;\r\n            transition: all .15s ease-in-out;\r\n            -webkit-transform: scale(0);\r\n            transform: scale(0);\r\n        }\r\n    }\r\n}\r\n\r\n.popup-menu-panel {\r\n    position: fixed;\r\n    width: 300px;\r\n\r\n    border-radius: 5%;\r\n    bottom: 80px;\r\n    left: 50%;\r\n    margin-left: -150px;\r\n    padding: 20px;\r\n    background-color: var(--ion-color-primary);\r\n    z-index: 102;\r\n    -webkit-transition: all .25s ease-in-out;\r\n    transition: all .25s ease-in-out;\r\n    -webkit-transition-delay: .15s;\r\n    transition-delay: .15s;\r\n    -webkit-transform-origin: 50% 100%;\r\n    transform-origin: 50% 100%;\r\n    -webkit-transform: scale(0);\r\n    transform: scale(0);\r\n    display: -webkit-box;\r\n    display: -moz-box;\r\n    display: -webkit-flex;\r\n    display: -moz-flex;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-flex-wrap: wrap;\r\n    -moz-flex-wrap: wrap;\r\n    -ms-flex-wrap: wrap;\r\n    flex-wrap: wrap;\r\n    .popup-menu-item {\r\n        margin: auto;\r\n        -webkit-box-flex: 1 0 30%;\r\n        -webkit-flex: 1 0 30%;\r\n        -moz-box-flex: 1 0 30%;\r\n        -moz-flex: 1 0 30%;\r\n        -ms-flex: 1 0 30%;\r\n        flex: 1 0 30%;\r\n        display: -webkit-box;\r\n        display: -moz-box;\r\n        display: -webkit-flex;\r\n        display: -moz-flex;\r\n        display: -ms-flexbox;\r\n        display: flex;\r\n        -webkit-box-direction: normal;\r\n        -webkit-box-orient: vertical;\r\n        -webkit-flex-direction: column;\r\n        -moz-flex-direction: column;\r\n        -ms-flex-direction: column;\r\n        flex-direction: column;\r\n        -webkit-transform: scale(0);\r\n        transform: scale(0);\r\n        opacity: 0;\r\n        -webkit-transition: all .25s ease-in-out;\r\n        transition: all .25s ease-in-out;\r\n        ion-icon {\r\n            margin: 0 auto;\r\n            text-align: center;\r\n            color: #fff;\r\n        }\r\n        span {\r\n            padding: 0;\r\n            margin: 0 0 auto 0;\r\n            color: #fff;\r\n            text-align: center;\r\n            font-size: 12px;\r\n            text-transform: uppercase;\r\n            font-weight: 500;\r\n            line-height: 18px;\r\n        }\r\n        &:active {\r\n            i {\r\n                color: rgb(221,65,53);\r\n                -webkit-transition: all .15s;\r\n                transition: all 0.15s;\r\n            }\r\n            span {\r\n                color: rgb(221,65,53);\r\n                -webkit-transition: all .15s;\r\n                transition: all .15s;\r\n            }\r\n        }\r\n    }\r\n    &.in {\r\n        -webkit-transform: scale(1);\r\n        transform: scale(1);\r\n        -webkit-transition-delay: 0s;\r\n        transition-delay: 0s;\r\n        .popup-menu-item {\r\n            -webkit-transform: scale(1);\r\n            transform: scale(1);\r\n            opacity: 1;\r\n            -webkit-transition-delay: .15s;\r\n            transition-delay: .15s;\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
